import { api } from 'src/pages/APIs';
import AbstractApiService from '../abstractApiService';

export default class InvoiceCalculationApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  // ── Discount Mapping ────────────────────────────────────────────────

  public async upsertDiscountMapping(
    prefix: string,
    percentage?: number | null,
    days?: number | null,
  ): Promise<any> {
    const body = new FormData();
    body.append('prefix', prefix);
    if (percentage !== null && percentage !== undefined) {
      body.append('percentage', String(percentage));
    }
    if (days !== null && days !== undefined) {
      body.append('days', String(days));
    }

    return super.post(api.discount_mapping_upsert, body);
  }

  public async listDiscountMappings(): Promise<any> {
    return super.get(api.discount_mapping_list);
  }

  public async deleteDiscountMapping(mappingId: string): Promise<any> {
    return super.deleteWithoutOrgId(
      api.discount_mapping_delete + '/' + encodeURIComponent(mappingId),
    );
  }

  // ── Payment Term Mapping ────────────────────────────────────────────

  public async upsertPaymentTermMapping(
    code: string,
    termType: string,
    days?: number,
    description?: string,
  ): Promise<any> {
    const body = new FormData();
    body.append('code', code);
    body.append('term_type', termType);
    if (days !== undefined) body.append('days', String(days));
    if (description) body.append('description', description);

    return super.post(api.payment_mapping_upsert, body);
  }

  public async listPaymentTermMappings(): Promise<any> {
    return super.get(api.payment_mapping_list);
  }

  public async deletePaymentTermMapping(mappingId: string): Promise<any> {
    return super.deleteWithoutOrgId(
      api.payment_mapping_delete + '/' + encodeURIComponent(mappingId),
    );
  }
}